export default __webpack_public_path__ + "static/back_img_3-33f0317fe51697496ea58d8d1f0978f4.png";